import React, { Component } from 'react';
import { Link } from 'react-router';
import '../styles/ProjectPage.scss';
import Nav from './Nav';
import Hero from './Hero';
import ProjectTitle from './ProjectTitle';
import ProjectAssets from './ProjectAssets';
import ProjectInfo from './ProjectInfo';

class ProjectPage extends Component {
  constructor() {
    super();

    this.onArrowKeyDown = this.onArrowKeyDown.bind(this);
  }

  static propTypes = {
    router: React.PropTypes.object.isRequired,
    params: React.PropTypes.object.isRequired,
    projects: React.PropTypes.object.isRequired,
    hasOpenModal: React.PropTypes.bool.isRequired
  };

  getNeighboringProjectIds() {
    const { projects, params } = this.props;
    const projectIds = Object.keys(projects);
    const currentProjectIndex = projectIds.indexOf(params.projectId);
    let prevProjectIndex = currentProjectIndex - 1;
    if (prevProjectIndex < 0) {
      prevProjectIndex = projectIds.length - 1;
    }
    const prevProjectId = projectIds[prevProjectIndex];
    let nextProjectIndex = currentProjectIndex + 1;
    if (nextProjectIndex === projectIds.length) {
      nextProjectIndex = 0;
    }
    const nextProjectId = projectIds[nextProjectIndex];
    return {
      prevProjectId,
      nextProjectId
    };
  }

  onArrowKeyDown(e) {
    if (this.props.hasOpenModal) return;
    const {
      prevProjectId,
      nextProjectId
    } = this.getNeighboringProjectIds();
    if (e.keyCode === 37) {
      this.props.router.push(`/project/${prevProjectId}`);
    }
    if (e.keyCode === 39) {
      this.props.router.push(`/project/${nextProjectId}`);
    }
  }

  componentWillMount() {
    document.addEventListener('keydown', this.onArrowKeyDown);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onArrowKeyDown);
  }

  render() {
    const {
      prevProjectId,
      nextProjectId
    } = this.getNeighboringProjectIds();
    return (
      <main className="ProjectPage">
        <Nav title="Project Overview" />
        <div className="hero-wrap">
          <Hero {...this.props} />
          <Link to={`/project/${prevProjectId}`} className="prev">
            <span>prev</span>
          </Link>
          <Link to={`/project/${nextProjectId}`} className="next">
            <span>next</span>
          </Link>
        </div>
        <ProjectTitle {...this.props} />
        <div className="content wrap">
          <div className="row">
            <div className="col-12 tab-6">
              <ProjectInfo {...this.props} />
            </div>
            <div className="col-12 tab-6">
              <ProjectAssets {...this.props} />
            </div>
          </div>
        </div>
      </main>
    );
  }
}

export default ProjectPage;



// WEBPACK FOOTER //
// ./src/components/ProjectPage.js